import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} HoursProps
 */

/**
 * Hours component.
 * @augments {Base<ComponentProps>}
 */
export default class Hours extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Hours',
    refs: ['btn', 'container', 'icon'],
  };

  /**
   * Click on button to open hours
   * @returns {void}
   */
  onClick() {
    this.$refs.container.classList.toggle('hidden');
    this.$refs.icon.classList.toggle('rotate-180');
  }
}
